import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    components: {
        globals
    },
    methods: {
        async getSalesSetting() {
            this.getCampagin();
            this.getSocialMedia();
            this.getMeeting();
            this.getContacted();
        },
        async addSalesSettings(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/leads/settings", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                    this.getSalesSetting()
                }
            })
        },
        async editSalesSettings(params,id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/leads/settings/"+id, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                    this.getSalesSetting()
                }
            })
        },
        async deleteSalesSettingsById(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/leads/settings/delete", {
                        data: params
                    })
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async createDealsPipeline(params){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/deals/settings", params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    }
                    else{
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async editDealsPipeline(id, params){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/deals/settings/" + id, params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    }
                    else{
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getDealsPipelineList(params){
            return new Promise(async (resolve,reject) => {
                let response = await this.$http.post(globals.CRM_SALES_URL + "/deals/settings/list", params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.reason)
                }
            })
        },
        async getDealsPipeline(id){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/deals/settings/"+id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteDealsPipeline(id){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/deals/settings/delete", {
                        data: { id:id }
                    })
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    }
                    else{
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getTerritoryList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL +`/deals/territories?skip=${params.skip}&limit=${params.limit}`);

                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async createTerritory(params){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/deals/territories", params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    }
                    else{
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async updateTerritory(id,params){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/deals/territories/" +id,params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    }
                    else{
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getTerritoryDetails(id){
            return new Promise(async (resolve,reject) => {
                let response = await this.$http.get(globals.CRM_SALES_URL + "/deals/territories/"+id)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.reason)
                }
            })
        },
        async deleteTerritoryById(id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/deals/territories/"+id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    //this.warning_msg = sessionStorage.getItem("error")
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async addInfoSettings(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/additional_info/save", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = sessionStorage.getItem("error")
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getAdditionalInformationList(params){
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post(globals.CRM_API + "/additional_info/list", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async DeleteAdditionalInformation(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(`${globals.CRM_API}/additional_info/delete?id=${params.id}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data.message)
                    } else {
                        reject(response.data.reason)
                        // this.warning_msg = response.response.reason
                        // this.$refs.warning_modal.open();
                        // setTimeout(() => {
                        //     this.$refs.warning_modal.close();
                        // }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = sessionStorage.getItem("error")
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getAddInfoDataById(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(`${globals.CRM_API}/additional_info/get?id=${params.id}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = sessionStorage.getItem("error")
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async editAddInfoById(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(`${globals.CRM_API}/additional_info/edit`, params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async UpdateVisibility(params){
            return new Promise(async (resolve,reject) => {
                try{
                    let response = await this.$http.get(`${globals.CRM_API}/additional_info/change_visibility?id=${params.id}&type=${params.type}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch(error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getQualifyingLeadList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL +`/leads/lead_settings?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}`);

                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async createQalifyingLead(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/leads/lead_settings", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async getSingleQualifyingLead(id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/leads/qualify_lead_stages/" + id);

                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteQualifyingLeadTemplateByID(lead_id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/leads/lead_settings/"+lead_id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async saveEdittedQualifyingLead(qualifying_lead_id, params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/leads/qualify_lead_stages/"+qualifying_lead_id, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/settings.js